import script from "./VvicFilterSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./VvicFilterSearch.vue?vue&type=script&setup=true&lang=ts"

import "./VvicFilterSearch.vue?vue&type=style&index=0&id=173f2ccb&scoped=true&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-173f2ccb"]])

export default __exports__